<template>
  <span>
    <a
      href="#"
      :class="'text-' + variant + ' ' + buttonClass"
      @click.prevent="() => $bvModal.show(modalName + item.id)"
    >
      <i class="fa fa-lg fa-print"></i>
    </a>
    <b-modal
      title="Imprimir etiquetas"
      @show="onShow"
      @ok="handleOk"
      :ok-disabled="isInvalid"
      :id="modalName + item.id"
    >
      <template slot="modal-ok">
        <b-spinner v-if="loading" small class="mr-1"></b-spinner>
        <span>OK</span>
      </template>
      <b-form-group label="Etiqueta">
        <b-form-select
          :state="$v.label.$dirty ? !$v.label.$error : null"
          v-model="$v.label.$model"
          value-field="id"
          text-field="name"
          :options="labels"
        />
      </b-form-group>
      <b-form-group>
        <label>Cantidad de etiquetas</label>
        <b-form-input
          type="number"
          :state="$v.label_qty.$dirty ? !$v.label_qty.$error : null"
          v-model="$v.label_qty.$model"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </span>
</template>

<script>
import vSelect from "vue-select";
import { PrintLabel } from "@/assets/js/printFunctions";
import { required, integer } from "vuelidate/lib/validators";

export default {
  name: "LabelForm",
  components: {
    vSelect
  },
  props: {
    buttonClass: {
      type: String,
      default: ""
    },
    modalName: {
      type: String,
      default: "label-form-modal"
    },
    item: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: () => "primary"
    }
  },
  data() {
    return {
      loading: false,
      label: null,
      label_qty: null,
      labels: [],
      waybillId: 123
    };
  },
  validations: {
    label: { required },
    label_qty: { required, integer }
  },
  computed: {
    isInvalid() {
      return this.loading || !this.label || !this.label_qty;
    }
  },
  methods: {
    onShow() {
      this.getLabels();
    },
    handleOk(evt) {
      evt.preventDefault();
      if (!this.loading) {
        this.loading = true;
        this.printLabel();
      }
    },
    async printLabel() {
      const thisV = this;
      let url = "";
      url = `supplies/supply-label/${thisV.label}/render_zpl/?waybill_id=${thisV.waybillId}`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$toast.info(`Enviando a impresora...`, "");
        thisV.loading = false;
        this.$bvModal.hide(this.modalName + this.item.id);
        PrintLabel(response.data.code, thisV.label_qty);
      } catch (error) {
        console.log(error);
        this.$bvModal.hide(this.modalName + this.item.id);
        thisV.loading = false;
        this.$toast.error("Ocurrió un error", "");
      }
    },
    async getLabels() {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `supplies/supply-label/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.labels = response.data;
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    }
  }
};
</script>

<style></style>
